import { render, staticRenderFns } from "./zNotificacao.vue?vue&type=template&id=31d193c4"
import script from "./zNotificacao.vue?vue&type=script&lang=js"
export * from "./zNotificacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports